import { render } from "./MobileOtp.vue?vue&type=template&id=667a6eac&scoped=true"
import script from "./MobileOtp.vue?vue&type=script&lang=js"
export * from "./MobileOtp.vue?vue&type=script&lang=js"

import "./MobileOtp.vue?vue&type=style&index=0&id=667a6eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667a6eac"]])

export default __exports__